import React from 'react';

import config from '../../config';
import { otherLinks } from './data.js';

const MobileLinkSection = () => (
  <section
    className="section section--yellow section--spacer honeyguide-app"
    id="mobile-app"
  >
    <div className="container">
      <div className="row">
        <div className="col-md-6 order-md-12">
          <img
            src={`${config.ASSETS_URL}/app-mobile.png`}
            alt="honeyguide mobile app"
            className="honeyguide-app-image"
          />
        </div>
        <div className="col-md-6 order-md-1">
          <h2 className="text-uppercase mb-4 section-header">
            Want HoneyGuide on the go?
            <br />
            Download the “Trekking in Nepal” app.
          </h2>
          <ul>
            <li>Mountain Finder and Maps.</li>
            <li>Safety Features and Contacts</li>
            <li>All Offline!!</li>
          </ul>
          <div className="mt-4">
            <a href={otherLinks.appStoreUrl} target="_blank" rel="noopener">
              <img
                src={`${config.ASSETS_URL}/appstore.png`}
                alt="appstore"
                className="store"
              />
            </a>
            <a href={otherLinks.playStoreUrl} target="_blank" rel="noopener">
              <img
                src={`${config.ASSETS_URL}/googleplay.png`}
                alt="playstore"
                className="store"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MobileLinkSection;



// WEBPACK FOOTER //
// ./src/screens/Landing/MobileLinkSection.jsx